export default [
  {
    path: "/finance-dashboard",
    name: "finance-main",
    component: () =>
      import("../../modules/Finance/pages/MainFinance/UI/FinanceDashboard.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["finance"],
    },
  },
  {
    path: "/my-salary",
    name: "my-salary",
    component: () =>
      import("../../modules/Finance/pages/AdminSalary/UI/MySalary.vue"),
    meta: {
      layout: "main",
      auth: true,
      requiresPin: true,
      role: [
        "admin",
        "finance",
      ],
    },
  },
  {
    path: "/admin-salary",
    name: "admin-salary",
    component: () =>
      import("../../modules/Finance/pages/AdminSalary/UI/AdminSalaryDashboard.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["finance", "admin"],
    },
  },
  {
    path: "/salary-documents",
    name: "finance-payslips",
    component: () =>
      import("../../modules/Finance/pages/SalaryDocument/UI/SalaryDocument.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["finance", "hr"],
    },
  },
  {
    path: "/finance-employee-info/:user_id",
    name: "finance-employee-info",
    component: () =>
      import("../../modules/Finance/pages/EmployeeInfo/UI/EmployeeInfo.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["finance"],
    },
  },
  {
    path: "/salary-info/group_id=:group_id",
    name: "finance-salary-info",
    component: () =>
      import("../../modules/Finance/widgets/SalaryInfo/SalaryInfo.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["finance"],
    },
  },
];
